<template>
    <div>
        <div :id="doAnchor" class="flex -mx-5 px-5 py-4 bg-white/5 items-center cursor-pointer" @click="toggleShow">
            <div class="flex space-between grow items-center">
                <div class="stepper-wrapper__small mr-2">
                    <div class="step" :class="[status ? status : '']">
                        <div class="step-circle"></div>
                    </div>
                </div>
                <h4 class="text-xl uppercase font-semibold">{{ label }}</h4>
            </div>
            <div class="items-center">
                <span class="icon-chevron" :class="[showAccordion ? 'active' : '']"></span>
            </div>
        </div>
        <transition
            enter-active-class="transition ease-out duration-500 transform"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class=""
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="showAccordion" class="pt-6 pb-8">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "AccordionComponent",
    props: {
        label: { type: String, default: "" },
        show: { type: Boolean, default: false },
        status: { default: "" },
        doAnchor: { type: String, default: "" },
    },
    data: function () {
        return {
            showAccordion: this.show,
        };
    },
    computed: {
        anchorLink() {
            return this.doAnchor ? "#" + this.doAnchor : "";
        },
    },
    methods: {
        toggleShow() {
            if (this.anchorLink) { // Anchor to the opened accordion
                this.$router.push({ hash: this.anchorLink });
            }
            this.showAccordion = !this.showAccordion;
        },
    },
};
</script>
